import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

interface GetShowPositivesListOptions {
    category: CreditCardProductCategory
    positives?: string[]
}

const showPositivesForCategoryList: CreditCardProductCategory[] = [
    CreditCardProductCategory.Rewards,
    CreditCardProductCategory.Cashback,
    CreditCardProductCategory.Travel,
    CreditCardProductCategory.PoorCredit,
]

export function getShowPositivesList({
    category,
    positives,
}: GetShowPositivesListOptions) {
    const hasPositives = Array.isArray(positives) && positives.length > 0

    return hasPositives && showPositivesForCategoryList.includes(category)
}
